<template>
  <layout v-if="$store.state.auth.uid">
    <template #header>
      <div class="flex column align-center p8">
        <h1 class="fas fa-wallet"></h1>
        <b>Wallet</b>
      </div>
      <a
        @click="
          show.section !== sectionkey
            ? ((show.section = sectionkey), (show.subsection = ''))
            : null
        "
        class="p8 bold sm-font"
        :key="sectionkey"
        v-for="(section, sectionkey) in sections"
        >{{ sectionkey.toUpperCase() }}</a
      >
    </template>
    <template #content>
      <div class="flex" v-if="$store.state.auth.uid">
        <div v-if="show.section" class="p8 container fill">
          <div class="flex align-center border-bottom p4 sm-font">
            <b class="bolder">{{ show.section.toUpperCase() }}</b>
            <i class="fa fa-chevron-right m4"></i>
            <select 
              class="r8"
              v-model="show.subsection"
              @change="inputs[show.section + show.subsection] = {}"
            >
              <option
                v-for="subsection in sections[show.section]"
                :key="subsection.name"
                :value="subsection.name"
              >
                {{ subsection.name.toUpperCase() }}
              </option>
            </select>
            <span v-if="show.section && show.subsection">{{
              sections[show.section].filter((a) => a.name == show.subsection)[0]
                .description
            }}</span>
          </div>
          <div v-if="show.section && show.subsection">
            <h3>
              {{
                sections[show.section]
                  .filter((a) => a.name == show.subsection)[0]
                  .name.toUpperCase()
              }}
            </h3>
            <fieldset
              @change="
                $set(
                  inputs,
                  show.section + show.subsection,
                  inputs[show.section + show.subsection]
                )
              "
              v-if="show.section && show.subsection"
            >
              <div
                :key="querykey"
                v-for="(query, querykey) in sections[show.section].filter(
                  (a) => a.name == show.subsection
                )[0].config.queries"
              >
                <input
                  v-model="inputs[show.section + show.subsection][querykey]"
                  v-if="['text', 'number'].includes(query)"
                  :placeholder="querykey"
                  :type="query"
                />
                <div v-else>
                  <b>{{querykey}}</b>
                  <iinput
                    v-model="inputs[show.section + show.subsection][querykey]"
                    view="json"
                  />
                </div>
              </div>
              <div>
                data: {{ inputs[show.section + show.subsection] }} 
                address:
                {{ urls }}
                <button
                  @click="
                    $store.dispatch('api', {
                      verb: 'get',
                      address: urls
                    })
                  "
                >
                  Send it
                </button>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
      <div class="container fill p4" v-if="$store.state.auth.uid">
        <div class="flex align-center wrap around sub-container">
          <button class="sm-font" type="button" @click="createUser()">
            New User
          </button>
          <button class="sm-font" type="button" @click="createTx()">
            New Transaction
          </button>
          <select 
            class="sm-input"
            type="text"
            v-model="test.tokenType"
            placeholder="Token Fn Type"
          >
            <option value="createTx">Create</option>
          </select>
          <div class="fill flex between align-center p4 sm-font">
            From <input type="text" class="sm-input" v-model="tx.from" />
          </div>
          <div class="flex fill between align-center p4 sm-font">
            To <input type="text" class="sm-input" v-model="tx.to" />
          </div>
          <div class="flex fill between align-center p4 sm-font">
            Amount <input type="number" class="sm-input" v-model="tx.amount" />
          </div>
          <div class="flex fill between align-center p4 sm-font">
            Fee <input type="number" class="sm-input" v-model="tx.fee" />
          </div>
          <div class="flex fill between align-center p4 sm-font">
            Sign <input type="text" class="sm-input" v-model="tx.sign" />
          </div>
          <button class="fill" type="button" @click="sendTx()">
            Send Transaction
          </button>
        </div>
        <div>{{ user }}</div>
        <div>{{ tx }}</div>
        <div class="flex wrap container" id="wallet">
          <!-- EVM Wallet Section -->
          <div class="flexy sub-container">
            <div class="flex between align-center">
              <h2 class="flexx">EVM Wallet</h2>
              <a v-if="!evmWallet.connected" @click="connectEVMWallet()">Connect</a>
              <a v-else @click="disconnectEVMWallet()">Disconnect</a>
            </div>
            <div v-if="evmWallet.connected" class="p4">
              <div class="p4">
                <b>Address:</b> 
                <code class="xs-font">{{ evmWallet.address }}</code>
                <button class="xs-font p2" @click="$copyText(evmWallet.address)">
                  <i class="fa fa-copy"></i>
                </button>
              </div>
              <div class="p4">
                <b>Network:</b> {{ evmWallet.network || 'Unknown' }}
              </div>
              <div class="p4">
                <b>Balance:</b> {{ evmWallet.balance || '0' }} ETH
              </div>
              <div class="p4" v-if="evmWallet.contracts && evmWallet.contracts.length > 0">
                <b>Connected Contracts:</b>
                <div v-for="contract in evmWallet.contracts" :key="contract.address" class="p2 xs-font">
                  {{ contract.name }}: {{ contract.address }}
                </div>
              </div>
            </div>
            <div v-else class="p4">
              <p class="xs-font">Connect your EVM wallet to interact with smart contracts</p>
              <button class="p4 update" @click="connectEVMWallet()">
                Connect Wallet
              </button>
            </div>
          </div>
          
          <div class="flexy sub-container">
            <div class="flex between align-center">
              <h2 class="flexx">XYM Tokens</h2>
              <a @click="show.section = 'activate'">Activate</a>
            </div>
            <div v-if="show.section === 'activate'">
              <div class="fill">
                <p>Next token price</p>
                <p>Total System Value</p>
              </div>
              <div class="flex around wrap">
                <div class="flex flexy fill" v-if="show.section === 'activate'">
                  <input type="number" min="1" class="r4" placeholder="qty" />
                  <button type="button" class="p8 success">
                    <i class="fas fa-plus r4"></i> Activate Tokens
                  </button>
                </div>
              </div>
            </div>
            <h3>Your XYM</h3>
            <h3>Dividends Earned</h3>
          </div>
          <div class="flexy sub-container">
            <div class="flex between align-center">
              <h2 class="flexx">XY Coins</h2>
              <div class="flex around flexy">
                <a @click="show.section = 'send'">Send</a>
                <a @click="show.section = 'request'">Request</a>
              </div>
            </div>
            <h3>Holdings</h3>
            <div class="flex around wrap">
              <div class="flex flexy" v-if="show.section === 'send'">
                <input type="number" min="1" class="r4 fill" />
                <button type="button" class="p8 update">
                  <i class="fas fa-minus r4"></i> Send Payment
                </button>
              </div>
              <div class="flex flexy" v-if="show.section === 'request'">
                <input type="number" min="1" class="r4" />
                <button type="button" class="p8 update">
                  <i class="fas fa-plus r4"></i> Request Payment
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer> Wallet stats </template>
  </layout>
  <div v-else>
    <login></login>
  </div>
</template>
<script>
export default {
  name: "wallet",
  computed: {
    urls: function () {
      if (!this.sections) return
      let url = this.sections[this.show.section].filter(
        (a) => a.name == this.show.subsection
      )[0].config.url +
        "?" +
        Object.entries(
          this.inputs[this.show.section + this.show.subsection]
        ).map(
          (x, xi) =>
            x[0] +
            "=" +
            x[1] +
            (xi + 1 !==
            Object.entries(
              this.inputs[this.show.section + this.show.subsection]
            ).length
              ? "&"
              : "")
        );
        return url.replaceAll('&,', '&')
    },
  },
  data() {
    return {
      show: {
        section: "",
        subsection: "",
      },
      user: {
        address: "",
        private: "",
        public: "",
      },
      tx: {
        from: "",
        to: "",
        amount: 0,
        fee: 0,
        sign: "",
      },
      evmWallet: {
        connected: false,
        address: "",
        network: "",
        balance: "",
        provider: null,
        contracts: [],
      },
      search: {},
      test: {
        tokenType: "createTx",
      },
      inputs: (() => {
        let inputobj = {};
        Object.keys(this.$store.state.wallet.sections).map((x) =>
          this.$store.state.wallet.sections[x].map(
            (y) => (inputobj[x + y.name] = {})
          )
        );
        return inputobj;
      })(),
      sections: this.$store.state.wallet.sections,
    };
  },
  methods: {
    async createUser() {
      this.$store.dispatch('token', {type: 'log'})
      this.user = await this.$store
        .dispatch("token", { type: "createUser" })
        .then((data) => data);
    },
    createTx() {
      this.tx.from = "mkDpHMUt6DNhmkTS6k94VAJ7rUVXneiXRf";
      this.tx.to = this.user.address;
      this.tx.amount = 1000;
      this.tx.fee = 100;
      this.tx.sign = this.user.keyPair.__Q.toString("hex");
    },
    sendTx() {
      this.tx.fee = Number(this.tx.fee);
      this.tx.amount = Number(this.tx.amount);
      this.$store.dispatch("token", { type: "createTx", tx: this.tx });
    },
    requestTx() {},
    getBalance() {},
    async connectEVMWallet() {
      try {
        // Check if MetaMask or other wallet is available
        if (typeof window.ethereum !== 'undefined') {
          // Request account access
          const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
          
          if (accounts.length > 0) {
            this.evmWallet.address = accounts[0];
            this.evmWallet.connected = true;
            this.evmWallet.provider = window.ethereum;
            
            // Get network
            const chainId = await window.ethereum.request({ method: 'eth_chainId' });
            this.evmWallet.network = this.getNetworkName(chainId);
            
            // Get balance
            await this.updateEVMBalance();
            
            // Load connected contracts from app state
            this.loadConnectedContracts();
            
            // Listen for account changes
            window.ethereum.on('accountsChanged', (accounts) => {
              if (accounts.length > 0) {
                this.evmWallet.address = accounts[0];
                this.updateEVMBalance();
              } else {
                this.disconnectEVMWallet();
              }
            });
            
            // Listen for network changes
            window.ethereum.on('chainChanged', (chainId) => {
              this.evmWallet.network = this.getNetworkName(chainId);
              this.updateEVMBalance();
            });
            
            // Save wallet connection to user profile
            await this.saveWalletToProfile();
          }
        } else {
          alert('Please install MetaMask or another EVM-compatible wallet');
        }
      } catch (error) {
        console.error('Error connecting wallet:', error);
        alert('Failed to connect wallet: ' + error.message);
      }
    },
    disconnectEVMWallet() {
      this.evmWallet.connected = false;
      this.evmWallet.address = "";
      this.evmWallet.network = "";
      this.evmWallet.balance = "";
      this.evmWallet.provider = null;
      this.evmWallet.contracts = [];
    },
    async updateEVMBalance() {
      if (!this.evmWallet.provider || !this.evmWallet.address) return;
      
      try {
        const balance = await this.evmWallet.provider.request({
          method: 'eth_getBalance',
          params: [this.evmWallet.address, 'latest'],
        });
        
        // Convert from wei to ETH
        this.evmWallet.balance = (parseInt(balance, 16) / Math.pow(10, 18)).toFixed(4);
      } catch (error) {
        console.error('Error fetching balance:', error);
      }
    },
    getNetworkName(chainId) {
      const networks = {
        '0x1': 'Ethereum Mainnet',
        '0x5': 'Goerli',
        '0x89': 'Polygon',
        '0x13881': 'Mumbai',
        '0x38': 'BSC',
        '0x61': 'BSC Testnet',
        '0x539': 'Local',
      };
      return networks[chainId] || `Chain ${chainId}`;
    },
    loadConnectedContracts() {
      // Load contracts from app state that have deployments
      const contracts = this.$store.state.app.advanced.smartcontracts || {};
      this.evmWallet.contracts = [];
      
      Object.entries(contracts).forEach(([contractId, contract]) => {
        if (contract.deployments) {
          Object.entries(contract.deployments).forEach(([network, deployment]) => {
            if (network === this.evmWallet.network.toLowerCase() || 
                this.evmWallet.network.toLowerCase().includes(network)) {
              this.evmWallet.contracts.push({
                id: contractId,
                name: contract.name,
                address: deployment.address,
                network: network,
              });
            }
          });
        }
      });
    },
    async saveWalletToProfile() {
      // Save wallet address to user profile
      if (!this.$store.state.auth.uid) return;
      
      const userWallet = {
        address: this.evmWallet.address,
        network: this.evmWallet.network,
        connected: true,
        lastConnected: Date.now(),
      };
      
      // Update user profile with wallet info
      this.$set(this.$store.state.users[this.$store.state.auth.uid], 'evmWallet', userWallet);
      
      await this.$store.dispatch('update', {
        type: 'user',
        data: { evmWallet: userWallet },
      });
    },
  },
  async mounted() {
    // Check if wallet was previously connected
    if (this.$store.state.auth.uid && this.$store.state.users[this.$store.state.auth.uid]) {
      const userWallet = this.$store.state.users[this.$store.state.auth.uid].evmWallet;
      if (userWallet && userWallet.connected && typeof window.ethereum !== 'undefined') {
        // Try to reconnect
        try {
          const accounts = await window.ethereum.request({ method: 'eth_accounts' });
          if (accounts.length > 0 && accounts[0].toLowerCase() === userWallet.address.toLowerCase()) {
            this.evmWallet.address = accounts[0];
            this.evmWallet.connected = true;
            this.evmWallet.provider = window.ethereum;
            
            const chainId = await window.ethereum.request({ method: 'eth_chainId' });
            this.evmWallet.network = this.getNetworkName(chainId);
            
            await this.updateEVMBalance();
            this.loadConnectedContracts();
          }
        } catch (error) {
          console.error('Error reconnecting wallet:', error);
        }
      }
    }
  },
};
</script>
